import React, { useEffect } from 'react';
import { Container, Spinner } from 'reactstrap';
import useMemoryGameStore from '../../store/memoryGameStore';
import { useFeatureFlag } from '../../store/configStore';
import { useRegisterFocusMode, FocusModePriority } from '../../store/focusModeStore';
import GameHeader from './components/GameHeader';
import MemoryBoard from './components/MemoryBoard';
import FactModal from './components/FactModal';
import GoldenModal from './components/GoldenModal';
import WinModal from './components/WinModal';
import styles from './MemoryGameContainer.module.scss';

const MemoryGameContainer = ({ style = {} }) => {
    const isMemoryGameActive = useFeatureFlag('memoryGame');

    useRegisterFocusMode('memoryGame', FocusModePriority.COMPONENT, false, true, isMemoryGameActive);

    const { loading, fetchGameData } = useMemoryGameStore();

    useEffect(() => {
        if (isMemoryGameActive) {
            fetchGameData();
        }
    }, [fetchGameData, isMemoryGameActive]);

    if (!isMemoryGameActive) {
        return null;
    }

    if (loading) {
        return (
            <Container className="text-center py-5" style={style}>
                <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                <p className="mt-3 text-muted">Spieldaten werden geladen...</p>
            </Container>
        );
    }

    return (
        <div className={styles.gameContainer} style={style}>
            <GameHeader />
            <MemoryBoard />
            <FactModal backdropClassName={styles.gameModalBackdrop} />
            <GoldenModal backdropClassName={styles.gameModalBackdrop} />
            <WinModal backdropClassName={styles.gameModalBackdrop} />
        </div>
    );
};

export default MemoryGameContainer;
